import { render, staticRenderFns } from "./RecipeSubRecipes.vue?vue&type=template&id=79baf102"
import script from "./RecipeSubRecipes.vue?vue&type=script&lang=js"
export * from "./RecipeSubRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports